import { elencoletture } from "../../config/elencoletture";
import { Card } from "../../components/card/Card";
import {Helmet} from "react-helmet"

export const Letture = () => {
    return (
        <>
        <title>
            <Helmet> Letture </Helmet>
        </title>
        <section id="download" className="bgCream textBlue">
            <h1 className="py-4 text-center">Letture</h1>
            <div className="container py-4">
                <div className="row g-4">
                    {elencoletture.map((el, index) => {
                        return (
                            <div className="col-12 col-lg-4 col-md-6">
                                <Card obj={el} index={index} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
        </>
    );
};
